<template>
  <div
    class="box"
    :class="[
      box.layout === 'horizontal' ? 'row' :
      box.layout === 'baseline' ? 'baseline' : 'column'
    ]"
  >
    <component
      v-for="(item, i) in box.contents"
      :key="i"
      :is="resolveComponent(item)"
      v-bind="item.type === 'box' ? { box: item } : { item }"
    />
  </div>
</template>

<script setup>
import { defineAsyncComponent } from 'vue'
import TextItem from './items/TextItem.vue'
import ImageItem from './items/ImageItem.vue'
import ButtonItem from './items/ButtonItem.vue'
import SeparatorItem from './items/SeparatorItem.vue'
import IconItem from './items/IconItem.vue'

const props = defineProps({
  box: {
    type: Object,
    required: true
  }
})

const AsyncBox = defineAsyncComponent(() => import('./Box.vue'))
const AsyncUnknown = defineAsyncComponent(() => import('./Unknown.vue'))

const resolveComponent = (item) => {
  switch (item.type) {
    case 'text': return TextItem
    case 'image': return ImageItem
    case 'button': return ButtonItem
    case 'separator': return SeparatorItem
    case 'icon': return IconItem
    case 'box': return AsyncBox
    default: return AsyncUnknown
  }
}
</script>

<style scoped>
.box {
  display: flex;
  gap: 6px;
}

.column { flex-direction: column; }
.row { flex-direction: row; }
.baseline { align-items: baseline; }
</style>
